import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { ChevronRight, Calendar, User } from "lucide-react";
import RichContent from "../components/RichContent";
import useDocumentTitle from "../lib/useDocumentTitle";

export default function BlogDetail() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(r => setP(r.data)).catch(() => setP(null)); }, [slug]);

  useDocumentTitle(p?.title || null, p?.meta_desc || null);

  if (!p) return <div className="py-20 text-center text-gray-500">Loading...</div>;

  return (
    <article className="bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <nav className="text-xs text-gray-500 mb-4 flex items-center gap-1.5">
          <Link to="/" className="hover:text-[#F7941D]">Home</Link>
          <ChevronRight className="w-3 h-3" />
          <Link to="/blog" className="hover:text-[#F7941D]">Blog</Link>
          <ChevronRight className="w-3 h-3" />
          <span className="text-[#1a3c5e] font-semibold truncate">{p.title}</span>
        </nav>
        <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded bg-[#FEF3E2] text-[#F7941D]">{p.category}</span>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#1a3c5e] mt-3 leading-tight">{p.title}</h1>
        <div className="flex items-center gap-4 text-xs text-gray-500 mt-3">
          <span className="flex items-center gap-1.5"><User className="w-3.5 h-3.5" /> {p.author}</span>
          <span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {new Date(p.published_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}</span>
        </div>
        <div className="aspect-[16/9] rounded-2xl overflow-hidden mt-6">
          <img src={p.cover_image} alt={p.title} className="w-full h-full object-cover" />
        </div>
        <div className="mt-8 max-w-none">
          <RichContent text={p.content} />
        </div>
        <div className="mt-10 bg-[#FEF3E2] rounded-2xl p-6 text-center">
          <h3 className="font-display text-xl font-bold text-[#1a3c5e]">Ready to design your home?</h3>
          <p className="text-sm text-gray-600 mt-1 mb-4">Get professional drawings starting at ₹8,500.</p>
          <Link to="/services">
            <button className="px-6 py-2.5 bg-[#F7941D] hover:bg-[#e0861a] text-white font-semibold rounded-xl">View Packages</button>
          </Link>
        </div>
      </div>
    </article>
  );
}
